export default __webpack_public_path__ + "static/media/Etape6_Buisson_fond_Monthibert.a50e8005.jpg";